<script lang="ts">
	import Loading from '$lib/svg/loading.svg.svelte';
	import { cubicIn, cubicOut } from 'svelte/easing';
	import { fly, slide } from 'svelte/transition';
	import { widgetCurrentStep, type WidgetStepType } from '../flow';
	import WidgetFooter from './WidgetFooter.svelte';
	import WidgetRestartButton from './WidgetRestartButton.svelte';
	import WidgetTitle from './WidgetTitle.svelte';

	interface Props {
		title?: string;
		widgetStep?: WidgetStepType | undefined;
		hideRestartButton?: boolean;
		loaded?: boolean;
		children?: import('svelte').Snippet;
	}

	let {
		title = '',
		widgetStep = undefined,
		hideRestartButton = false,
		loaded = true,
		children
	}: Props = $props();

	let show = $state(false);
	$effect(() => {
		if (loaded && (widgetStep === $widgetCurrentStep || widgetStep === undefined)) {
			setTimeout(() => {
				if (widgetStep === $widgetCurrentStep || widgetStep === undefined) {
					show = true;
				}
			}, 10);
		}
	});
</script>

<div class="flex flex-col lg:flex-row-reverse gap-4 w-full h-fit">
	<div class="w-full" out:fly={{ easing: cubicIn, y: -10, duration: 300 }}>
		{#if show}
			<div class="w-full" in:fly={{ easing: cubicOut, y: 10, duration: 300, delay: 400 }}>
				{#if show && (widgetStep === $widgetCurrentStep || widgetStep === undefined)}
					<div
						transition:slide={{ duration: 400, delay: 100, axis: 'y' }}
						class={show ? '' : 'hidden'}
					>
						{#if title}
							<WidgetTitle>{title}</WidgetTitle>
						{/if}
						{@render children?.()}
						{#if !hideRestartButton}
							<WidgetRestartButton />
						{/if}
						<WidgetFooter />
					</div>
				{/if}
			</div>
		{:else}
			<Loading className="w-8 h-8 mx-auto mt-8" width="w-12" />
		{/if}
	</div>
</div>
